import { Button, Stack, Typography } from '@mui/material';

export const SUGGESTED_QUESTIONS = [
  'Why did this household get this score?',
  'Which narrative threads support the score?',
  'What did Loom not see?',
] as const;

export function SuggestedQuestions({ onPick, disabled }: { onPick: (question: string) => void; disabled?: boolean }) {
  return (
    <Stack gap={1} data-testid="chat-suggestions">
      <Typography variant="body2" color="text.secondary">
        Ask about this household's application and Community Impact Potential. Try:
      </Typography>
      {SUGGESTED_QUESTIONS.map((q) => (
        <Button key={q} variant="outlined" size="small" disabled={disabled} onClick={() => onPick(q)} sx={{ justifyContent: 'flex-start', textAlign: 'left' }}>
          {q}
        </Button>
      ))}
    </Stack>
  );
}
